<template>
    <div class="three-images-preset1">
        <div class="img">
            <img :src="leftImage" class="img-fluid" />
        </div>
        <div class="img">
            <img :src="middleImage" class="img-fluid" />
        </div>
        <div class="img">
            <img :src="rightImage" class="img-fluid" />
        </div>
    </div>
</template>

<script>

export default {
    name: 'LandingPageGalleryDefault',
    props: {
        leftImage: {
            type: String,
        },
        middleImage: {
            type: String,
        },
        rightImage: {
            type: String,
        }
    }
}
</script>
